import React, { useEffect, useState } from 'react';
import './BigListing.css';
import { VscUnverified } from "react-icons/vsc";
import { VscVerifiedFilled } from "react-icons/vsc";
import bsc from '../../assets/bsc.png';
import eth from '../../assets/eth.png';
import sol from '../../assets/sol.png';
import arbitrum from '../../assets/arbitrum.svg';
import base from '../../assets/base.svg';
import polygon from '../../assets/polygon.svg';
import avax from '../../assets/avax.webp';
import pepu from '../../assets/pepu.webp';
import robin from '../../assets/robin.svg';
import UnlistedLogo from '../../assets/unlisted-logo.png';
import { AiOutlineSafetyCertificate   } from "react-icons/ai";
import { PiTelegramLogoLight } from "react-icons/pi";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { AiOutlineStop } from "react-icons/ai";
import { RiTwitterXFill } from "react-icons/ri"; 
import { TbWorldWww } from "react-icons/tb";
import { TokenItem } from '../../utils/types';
import { MdVerified } from "react-icons/md";
import { PiFingerprint } from "react-icons/pi";
import { AiOutlinePushpin } from "react-icons/ai";

const Pin = AiOutlinePushpin as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const KYC = PiFingerprint  as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const Verified = MdVerified  as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const InfoIcon = AiOutlineInfoCircle  as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const UnlistedIcon = AiOutlineStop  as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const TimesIcon = AiOutlineSafetyCertificate  as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const Unverified = VscUnverified as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const TG = PiTelegramLogoLight  as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const X = RiTwitterXFill  as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const WWW = TbWorldWww  as unknown as React.FC<React.SVGProps<SVGSVGElement>>;

interface ProjectInterface {
  verified?: string;
  image?: string;
  chain?: string;
  title?: string;
  symbol?: string;
  countdown?: string;
  address?: string;
  badges?: Badges;
  round?: string;
  banner?: string;
  isad?: boolean;
  url?: string;
}

interface Badges {
  Audited: string;
  KYC: string;
  SAFU: string;
  Based: string;
}

const BigListing: React.FC<ProjectInterface> = ({
  verified,
  image,
  chain,
  title,
  symbol,
  countdown,
  address,
  badges,
  round,
  banner,
  isad,
  url
}) => {

  const [chainId, setChainId] = useState<any>(null);
  const [data, setData] = useState<any>(null);
  const [isListed, setIsListed] = useState<any>(null);


  const chainImages: { [key: string]: string } = {
    bsc: bsc,
    eth: eth,
    sol: sol,
    solana: sol,
    arbitrum: arbitrum,
    base: base,
    polygon: polygon,
    avax: avax,
    pepu: pepu,
    robin: robin
  };

  const chainLogo = chain
    ? chainImages[chain.toLowerCase()] || UnlistedLogo
    : UnlistedLogo;

  useEffect(() => {
    if (!chain) return;
    const lowerChain = chain.toLowerCase();
    if (lowerChain === 'bsc') {
      setChainId(56);
    } else if (lowerChain === 'eth') {
      setChainId(1);
    } else if (lowerChain === 'sol' || lowerChain === 'solana') {
      setChainId(501424);
    } else if (lowerChain === 'base') {
      setChainId(8453);
    } else if (lowerChain === 'arbitrum') {
      setChainId(42161);
    } else if (lowerChain === 'polygon') {
      setChainId(137);
    } else if (lowerChain === 'avax') {
      setChainId(43114);
    } else if (lowerChain === 'robin') {
      setChainId(4663);
    } else {
      setChainId(null);
    }
  }, [chain]);

  useEffect(() => {
    if (address === null || chainId === null) return;
    const fetchData = async () => {
      try {
        const response = await fetch(`https://api.dexview.com/pair?baseToken=${address}&chainId=${chainId}`, {
            headers: {
              "accept": "application/json, text/plain, */*",
              "accept-language": "nl-NL,nl;q=0.9,en-US;q=0.8,en;q=0.7",
              "if-none-match": "W/\"2244-8e+vWX7JgZT7/hBnItO2lL1ZTqo\"",
              "priority": "u=1, i",
              "sec-ch-ua": "\"Not(A:Brand\";v=\"99\", \"Google Chrome\";v=\"133\", \"Chromium\";v=\"133\"",
              "sec-ch-ua-mobile": "?0",
              "sec-ch-ua-platform": "\"Windows\"",
              "sec-fetch-dest": "empty",
              "sec-fetch-mode": "cors",
              "sec-fetch-site": "same-site",
              "secret": "5ff3a258-2700-11ed-a261-0242ac120002"
            },
            referrerPolicy: "same-origin",
            body: null,
            method: "GET",
            mode: "cors",
            credentials: "omit"
        });
        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }
        const result = await response.json();
        setData(result.data);
        if(result.data === null){
          setIsListed(false);
        } else{
          setIsListed(true);
        }
      } catch (error: any) {
        console.error(error);
      }
    };
    fetchData();

    const interval = setInterval(fetchData, 1000);
    return () => clearInterval(interval);
  }, [chainId, address]);

  const renderPriceChange = (change: string | number) => {
    const value = parseFloat(change as string);
    if (value > 999){
      return (
        <div className={`redgreen green`}>
          &gt;999%
        </div>
      );
    }
    const formattedValue = value.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    const changeClass = value >= 0 ? 'green' : 'red';
    
    if (formattedValue === "NaN" || !formattedValue) { return }

    return (
      <div className={`redgreen ${changeClass}`}>
        {formattedValue}%
      </div>
    );
  };


  const formatVolume = (volume: number): string => {
    if (volume === null || volume === undefined) return '0';

    if (Math.abs(volume) >= 1_000_000_000) {
      return (
        (volume / 1_000_000_000).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }) + 'B'
      );
    } else if (Math.abs(volume) >= 1_000_000) {
      return (
        (volume / 1_000_000).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }) + 'M'
      );
    } else if (Math.abs(volume) >= 1_000) {
      return (
        (volume / 1_000).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }) + 'K'
      );
    }
    return volume.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  return (
    <a className='card-link-big' target={url ? '_blank' : '_self'} href={url || `/${chain}/${address}`}>
        {banner && banner?.startsWith('http') && (verified === "true" || verified === "yes") && (
          <img src={banner} className={`display-banner-biglisting`}></img>
        )}
      <div className={`big-card ${isad && ('big-card-pinned')}`}>
        <div className="big-card-top-part">
          <div className="big-logo">
            <img src={image?.startsWith('http') ? image : UnlistedLogo} className={`big-logo-img ${(verified === "true" || verified === "yes") && ("verifiedborder")}`} />
            <img src={chainLogo} className='chain-image-biglisting' />
          </div>
          <div className="big-middle">
            <div className="big-middle-top">
              <h3>{title}</h3>
              <div className="symbol-socials">
                {symbol}
              </div>
            </div>
            {isListed && data && (
              <div className="big-middle-bottom">
                <div className="mc-bottom">
                  MC: ${formatVolume(data.fdv)}
                </div>
                <div className="price-change-big">
                  {renderPriceChange(formatVolume(data.newInformation?.priceChange24h))}
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="big-card-bottom-part">
          <div className={`bottom-badges-item ${(verified === "true" || verified === "yes") && ("isverified")}`}>
             {(verified === "true" || verified === "yes") ? ("Verified"): "Unverified"}
          </div>
          <div className={`bottom-badges-item ${badges?.Audited === "true" && ("isaudited")}`}>
             {badges?.Audited === "true" ? ("Audited"): "No Audit"}
          </div>
          <div className={`bottom-badges-item ${badges?.KYC === "true" && ("isaudited")}`}>
            {badges?.KYC === "true" ? ("KYC"): "No KYC"}
          </div>
          <div className="bottom-badges-item agotime">
            {isad ? (
              <div className='pin-promoted'><Pin /> AD</div>
            ) : countdown}  
          </div>
        </div>
      </div>
    </a>
  );
};

export default BigListing;
